import Tag from '~/components/Tag'
import i from '~/i18n'

export const labels = {
  title: i.t('rm:campaign.create.ObjectiveBased.products.title'),
  description: {
    initial: i.t('rm:campaign.create.ObjectiveBased.products.description'),
    done: (length: number) => (
      <>
        {i.t(
          'rm:campaign.create.ObjectiveBased.products.description.completed'
        )}
        <Tag>
          {i.t(
            'rm:campaign.create.ObjectiveBased.products.description.completed.products',
            { count: length }
          )}
        </Tag>
      </>
    )
  }
}
